export const fields = {
  companyAdditionalRevenueStreamID: {
    label: "companyAdditionalRevenueStreamID",
    type: "number",
    rules: "required|numeric",
  },
  serviceName: {
    label: "Service Name",
    type: "text",
    rules: "required|string",
  },
  value: {
    label: "Value",
    rules: "required",
    value: "0",
  },
  date: {
    label: "Date",
    type: "date",
    rules: "required|date",
  },
  createdBy: {
    label: "Created By",
    type: "text",
  },
  createdOn: {
    label: "Created On",
    type: "text",
  },
  updatedBy: {
    label: "Updated By",
    type: "text",
  },
  updatedOn: {
    label: "Updated On",
    type: "text",
  },
};
